module.exports = __webpack_public_path__ + "img/ticket.f3916f27.svg";